<template>
  <div>
    <!-- Actions Toolbar -->
    <div class="has-background-white rounded-lg px-md py-sm mb-xxs">
      <div class="columns is-vcentered is-mobile">
        <div class="column is-narrow">
          <b-dropdown :disabled="loading || selected.length === 0">
            <button class="button" slot="trigger" slot-scope="{ active }" :disabled="selected.length === 0">
              <span>Actions</span>
              <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
            </button>
            <b-dropdown-item has-link><a href="#" @click.prevent class="has-text-grey-light">No Actions</a></b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column">
          <div class="has-text-right is-size-7">
            <!-- Counts -->
            <p v-if="loading">Loading...</p>
            <p v-else>
              {{ cancels.length }}
              {{ (cancels.length === 1) ? 'cancel' : 'cancels' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Results -->
    <div>
      <b-table
        :data="cancels"
        :checked-rows.sync="selected"
        :mobile-cards="false"
        :loading="loading"
        hoverable
        checkable
        checkbox-position="left"
        class="is-size-7">
        <template>
          <!-- ID -->
          <b-table-column
            label="ID"
            header-class="nowrap"
            cell-class="nowrap"
            width="96"
            v-slot="props">
            <a href="#"
              class="has-text-weight-bold has-text-info"
              @click.prevent="inspectCancel = props.row"
            >{{ props.row.id }}</a>
          </b-table-column>
          <!-- Created At -->
          <b-table-column
            label="Registered"
            header-class="nowrap"
            cell-class="nowrap"
            v-slot="props">
            <span>{{ $dates.utc(props.row.created_at).local().format('MMM D, YYYY @ h:mm A') }}</span>
          </b-table-column>
          <!-- Approved At -->
          <b-table-column
            label="Approved"
            header-class="nowrap"
            cell-class="nowrap"
            v-slot="props">
            <span v-if="props.row.approved_at === null">--</span>
            <span v-else>{{ $dates.utc(props.row.approved_at).local().format('MMM D, YYYY @ h:mm A') }}</span>
          </b-table-column>
          <!-- Rejected At -->
          <b-table-column
            label="Rejected"
            header-class="nowrap"
            cell-class="nowrap"
            v-slot="props">
            <span v-if="props.row.rejected_at === null">--</span>
            <span v-else>{{ $dates.utc(props.row.rejected_at).local().format('MMM D, YYYY @ h:mm A') }}</span>
          </b-table-column>
          <!-- Expires At -->
          <b-table-column
            label="Expires On"
            header-class="nowrap"
            cell-class="nowrap"
            width="150"
            v-slot="props">
            <span v-if="props.row.expires_at === null">--</span>
            <span v-else>{{ $dates.utc(props.row.expires_at).local().format('MMM D, YYYY @ h:mm A') }}</span>
          </b-table-column>
          <!-- Status -->
          <b-table-column
            label="Status"
            header-class="nowrap"
            cell-class="nowrap"
            v-slot="props">
            <span v-if="props.row.status === 'pending'" class="has-text-warning has-text-weight-bold">Pending</span>
            <span v-if="props.row.status === 'approved'" class="has-text-success has-text-weight-bold">Approved</span>
            <span v-if="props.row.status === 'rejected'" class="has-text-danger has-text-weight-bold">Rejected</span>
            <span v-if="props.row.status === 'expired'" class="has-text-danger has-text-weight-bold">Expired</span>
          </b-table-column>
        </template>
        <template #empty>
          <div class="py-lg has-text-grey has-text-centered">
            <p>No request have been registered yet.</p>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Inspect Modal -->
    <b-modal
      v-if="(inspectCancel !== null)"
      has-modal-card
      :active="(inspectCancel !== null)"
      :can-cancel="['escape', 'x']"
      @close="closeModals"
      ><CancelRequestModal :selectedCancel="inspectCancel" @cancel:acknowledged="cancelAcknowledged"/>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CancelRequestModal from '@/components/Modals/Cancel/CancelRequestModal'

export default {
  components: {
    CancelRequestModal
  },
  data () {
    return {
      loading: false,
      selected: [],
      inspectCancel: null
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    closeModals () {
      this.inspectCancel = null
    },
    cancelAcknowledged () {
      this.$emit('cancel:acknowledged')
    }
  },
  mounted () {

  },
  props: ['orderId', 'cancels']
}
</script>
